export default __webpack_public_path__ + "static/media/lockpad-dark.b4590826.png";